// @flow

import React from 'react';
import type { ShoppingCenter } from '../../../../types/shoppingCenterType';
import { buildVizUrl } from '../../../../utils/tableauUtils';
import MarketingEmptyTile from './MarketingEmptyTile';

type Props = {
  shoppingCenter: ShoppingCenter,
}

const VIZ_URLS_BY_COUNTRY = {
  FR: 'https://dub01.online.tableau.com/t/urwtableau/views/Dash_Telco_16123566498490/PenetrationRate',
};

function PenetrationRateTableau({ shoppingCenter }: Props) {
  const vizUrl = VIZ_URLS_BY_COUNTRY[shoppingCenter.countryCode];

  if (vizUrl == null) {
    return <MarketingEmptyTile errorMessage="MKT_PAGE.NO_TABLEAU_VIEWS" />;
  }

  const vizQueryParams = () => ({
    iframeSizedToWindow: 'true',
    embed: 'true',
    showAppBanner: 'false',
    display_count: 'n',
    showVizHome: 'n',
    origin: 'card_share_link',
    bootstrapWhenNotified: 'y',
    tabs: 'n',
    device: window.innerWidth <= 768 ? 'phone' : 'tablet',
    apiID: 'host2',
  });

  return (
    <tableau-viz
      id="tableauViz"
      src={buildVizUrl(vizUrl, vizQueryParams())}
      device={window.innerWidth <= 768 ? 'phone' : 'tablet'}
      hide-tabs
      toolbar="hidden"
      width="100%"
      height="1000px"
      disable-url-actions="false"
    >
      <viz-filter field="Center" value={shoppingCenter.name} />
    </tableau-viz>
  );
}

export default PenetrationRateTableau;
